import axios from "axios";
import {
    buildApiUrl,
    formatApiUnreachableMessage,
    getApiBaseUrl,
    isSupabaseFunctionsApi,
} from "../config/api";

function supabaseIntent(intent, fields) {
    return { intent, ...fields };
}

export async function requestPasswordReset(fields) {
    const payload = isSupabaseFunctionsApi(getApiBaseUrl())
        ? supabaseIntent("password-reset-request", {
              accountType: fields.accountType || "staff",
              email: fields.email,
              rollNum: fields.rollNum,
              studentName: fields.studentName,
              returnOrigin: fields.returnOrigin || (typeof window !== "undefined" ? window.location.origin : ""),
          })
        : {
              accountType: fields.accountType || "staff",
              email: fields.email,
              rollNum: fields.rollNum,
              studentName: fields.studentName,
              returnOrigin: fields.returnOrigin || (typeof window !== "undefined" ? window.location.origin : ""),
          };

    try {
        const res = await axios.post(buildApiUrl("/PasswordReset/request"), payload);
        return res.data;
    } catch (err) {
        if (axios.isAxiosError(err) && !err.response) {
            throw new Error(formatApiUnreachableMessage(getApiBaseUrl()));
        }
        throw err;
    }
}

export async function validatePasswordResetToken(token) {
    const useSupabase = isSupabaseFunctionsApi(getApiBaseUrl());

    try {
        if (useSupabase) {
            const res = await axios.post(buildApiUrl("/PasswordReset/validate"), {
                intent: "password-reset-validate",
                token,
            });
            return res.data;
        }

        const res = await axios.get(buildApiUrl(`/PasswordReset/validate/${encodeURIComponent(token)}`));
        return res.data;
    } catch (err) {
        if (axios.isAxiosError(err) && !err.response) {
            throw new Error(formatApiUnreachableMessage(getApiBaseUrl()));
        }
        throw err;
    }
}

export async function confirmPasswordReset(fields) {
    const payload = isSupabaseFunctionsApi(getApiBaseUrl())
        ? supabaseIntent("password-reset-confirm", {
              token: fields.token,
              newPassword: fields.newPassword,
          })
        : {
              token: fields.token,
              newPassword: fields.newPassword,
          };

    try {
        const res = await axios.post(buildApiUrl("/PasswordReset/confirm"), payload);
        return res.data;
    } catch (err) {
        if (axios.isAxiosError(err) && !err.response) {
            throw new Error(formatApiUnreachableMessage(getApiBaseUrl()));
        }
        throw err;
    }
}

export { MIN_PASSWORD_LENGTH } from "./passwordValidation";
